export const MIN_TEAM_SIZE = 2;
